export default "__VITE_ASSET__d9e5d3c7__"